import React from 'react'
import { withRouter } from 'react-router-dom'
import Page from './Page'
import V2PromoPage from './v2/V2PromoPage'
import V2NotFoundPage from './v2/V2NotFoundPage'
import '../styles/global.css'

const TIMER = 10

class V2Promo extends Page {
    state = {
        fetchingEvent: false,
        hasEvent: false,
        refreshingEvent: false,
        timer: 0
    }

    componentDidMount() {
        window.scrollTo(0, 0)
        this._refreshEvent = this._refreshEvent.bind(this)

        if (!this.props.client || !this.props.event) {
            this.setState({ fetchingEvent: true }, () => {
                this.props.fetchEvent(this.props.location.pathname, (hasEvent) => {
                    this._eventReady(hasEvent)
                })
            })
        } else {
            this.setState({ timer: 10 }, () => {
                this._eventReady(true)
            })
        }
    }

    componentWillUnmount() {
        if (this._interval) clearInterval(this._interval)
    }

    _eventReady(hasEvent) {
        this.setState({ hasEvent: hasEvent, fetchingEvent: false })
        this._interval = setInterval(this._refreshEvent, 1000)
    }

    _refreshEvent() {
        if (this.state.refreshingEvent || this.state.fetchingEvent) return
        this.setState({ timer: this.state.timer + 1 })
        if (this.state.timer >= TIMER) {
            this.setState({ refreshingEvent: true, timer: 0 }, () => {
                this.props.fetchEvent(this.props.location.pathname, (hasEvent) => {
                    this.setState({ hasEvent: hasEvent, refreshingEvent: false })
                })
            })
        }
    }

    render() {
        if (this.props.location.pathname === "/") {
            return <V2NotFoundPage />
        }

        if (!this.state.hasEvent || !this.props.client || !this.props.event) {
            return (
                <div className="public-event-loading">
                    <div className="public-event-loader">
                        <img src="/resources/s50.png" alt="" />
                    </div>
                </div>
            )
        }

        if (!this.props.event.v2) {
            return <V2NotFoundPage />
        }

        return <V2PromoPage client={this.props.client} event={this.props.event} />
    }
}

export default withRouter(V2Promo)
